import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

export interface IActions {
  dataAt?: string;
  disableGrow?: boolean;
  className?: string;
}

// tslint:disable-next-line:variable-name
const SActions = styled.section<{ hasMultipleChilds: boolean; disableGrow: boolean }>(
  ({ theme, hasMultipleChilds, disableGrow }) => `
  > button, > p {
    width: 100%;
    &:not(:last-child) {
      margin-bottom: ${theme.spacing.medium}px;
    }
  }
  @media only screen and (min-width: 800px) {
    display: flex;
    flex-grow: ${disableGrow ? 0 : 1};
    align-items: center;
    justify-content: ${hasMultipleChilds ? 'space-between' : 'center'};
    button, > p {
      width: auto;
      margin-bottom: 0;
    }
  }
`
);

// tslint:disable-next-line:variable-name
const Actions: React.FC<IActions> = (props) => {
  const hasMultipleChilds = Boolean(props.children && React.Children.count(props.children) > 1);
  return (
    <SActions
      className={props.className}
      disableGrow={Boolean(props.disableGrow)}
      hasMultipleChilds={hasMultipleChilds}
      data-at={props.dataAt ? props.dataAt : 'actions'}
    >
      {props.children}
    </SActions>
  );
};

export default Actions;
